import type { ElementType, ReactNode } from 'react';
import styles from './Text.module.css';

/** The type scale (piece 1): five variants, every one a font-size token at or above 11px. */
export type TextVariant = 'title' | 'subtitle' | 'body' | 'small' | 'caption';

export const textDocumentedStates: readonly TextVariant[] = ['title', 'subtitle', 'body', 'small', 'caption'];

export interface TextProps {
  variant?: TextVariant;
  as?: ElementType;
  children: ReactNode;
}

export function Text({ variant = 'body', as: Tag = 'span', children }: TextProps) {
  return (
    <Tag className={`${styles.text} ${styles[variant]}`} data-variant={variant}>
      {children}
    </Tag>
  );
}
